// Indicatore di caricamento della tab mentre arrivano i dati del nuovo anno di lavoro
export const TabLoading = ({ year }) => (
  <div className="tab-loading flex items-center gap-3 rounded-lg border border-border bg-card px-4 py-10 justify-center text-sm text-muted-foreground" data-testid="tab-loading" role="status">
    <span className="h-5 w-5 rounded-full border-2 border-primary border-t-transparent animate-spin" />
    Caricamento dei dati dell'anno {year}…
  </div>
);
